import React from 'react'
import { useStyles } from './styles'

interface UserSettingsTabProps {
    title: string
    children: React.ReactNode
}

export const UserSettingsTab: React.FC<UserSettingsTabProps> = ({ title, children }) => {
    const classes = useStyles()
    return (
        <div className={classes.root}>
            <h3 className={classes.title}>{title}</h3>
            {children}
        </div>
    )
}

export default React.memo(UserSettingsTab)
